import { ref } from 'vue'
import axios from 'axios'
import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"

const error = ref(null)

export const getImsiPricesList = async (token) => {
  log("welcome in getImsiPricesList")
  const API_URL = `${BASE_URL}/home/get_imsi_prices_api`
  error.value = null
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
    const result = await axios.get(API_URL, { headers })
    log("result.data from getImsiPricesList:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in getImsiPricesList:")
    log(err)
    error.value = err
    return { error: true, message: "Network error" }
  }
}

export const addImsiPrice = async (token, data) => {
  log("welcome in addImsiPrice")
  const API_URL = `${BASE_URL}/home/add_imsi_price_api`
  error.value = null
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
    const result = await axios.post(API_URL, data, { headers })
    log("result.data from addImsiPrice:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in addImsiPrice:")
    log(err)
    error.value = err
    return { error: true, message: "Network error" }
  }
}

export const updateImsiPrice = async (token, data) => {
  log("welcome in updateImsiPrice")
  const API_URL = `${BASE_URL}/home/update_imsi_price_api`
  error.value = null
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
    const result = await axios.put(API_URL, data, { headers })
    log("result.data from updateImsiPrice:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in updateImsiPrice:")
    log(err)
    error.value = err
    return { error: true, message: "Network error" }
  }
}

const useGetImsiPricesAPI = () => {
  return { getImsiPricesList, addImsiPrice, updateImsiPrice }
}

export default useGetImsiPricesAPI
